/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class Text extends BaseField {

    protected opts: TextOptions;

    constructor (element: string | JQuery, opts: TextOptions = {}) {
        super(element, opts);

        let self = this;

        if (this.opts.transform === 'uppercase') {
            this.element.css({ 'textTransform': 'uppercase' });
        }
    }

    public getValue() {
        let value = this.element.val();

        if (this.opts.transform === 'uppercase') {
            value = value.toLocaleUpperCase();
        }

        return value;
    }

}

interface TextOptions extends FieldOptions {
    transform?: 'uppercase';
}

}
